import axios from "axios";
import apiService from "./apiService";

const baseUrl = process.env.REACT_APP_API_URL;

export default {
  getConfigs: async machineId => await apiService.get(machineId),

  getConfig: async (machineId, eventId) =>
    apiService.get(`${machineId}/${eventId}`),

  createConfig: async data => {
    const eventName = data.get("eventName");
    return apiService.post(
      "",
      data,
      `Uploading config '${eventName}'.`,
      `Event '${eventName}' created.`
    );
  },

  createTemplateConfig: async (data, templateId) => {
    const eventName = data.get("eventName");

    return apiService.post(
      `template/${templateId}`,
      data,
      `Uploading config '${eventName}'.`,
      `Event '${eventName}' created.`
    );
  },

  updateConfig: async (id, data) => {
    const eventName = data.get("eventName");
    return apiService.put(
      id,
      data,
      `Uploading config '${eventName}'.`,
      `Event '${eventName}' updated.`
    );
  },

  deleteConfig: async id => apiService.del(id, "Event deleted")
};



// WEBPACK FOOTER //
// ./src/services/api/configService.js